import React, { Component } from 'react';
import EditPolicyStep2Page  from './edit-policy-step2-html';
class EditPolicyStep2 extends Component {
    constructor(props){
        super(props)
        window.scrollTo({top: 0, behavior: 'smooth'})
    }
    render() {
        return(
            <div>
                <EditPolicyStep2Page
                />
            </div>
        )
    }
}
export default EditPolicyStep2;